import { gql } from '@apollo/client';

export const EDIT_ORDER = gql`
  mutation v1_orders_edit($prm: order_edit_prm!) {
    v1_orders_edit(prm: $prm)
  }
`;